/*
 * Os identificadores que o GA4 guarda no navegador.
 *
 * A venda só é concluída dias depois, quando a equipe finaliza o pedido no
 * painel — e é o servidor que avisa o GA4 nessa hora. Para essa venda cair na
 * mesma visita (e na mesma campanha) de quem comprou, o servidor precisa do
 * client_id e do session_id que o GA4 deu a este navegador. Eles saem dos
 * cookies e seguem com o pedido.
 *
 * São identificadores anônimos, sorteados pelo próprio GA4: nenhum dado da
 * pessoa vai junto.
 */

import { analyticsPermitido } from '../consentimento';

const MEASUREMENT_ID = 'G-4NK4CT7D93';

function lerCookie(nome: string): string | null {
  try {
    const par = document.cookie.split('; ').find((c) => c.startsWith(`${nome}=`));
    return par ? decodeURIComponent(par.slice(nome.length + 1)) : null;
  } catch {
    return null;
  }
}

/** "GA1.1.1234567890.1700000000" → "1234567890.1700000000". */
export function clientIdDoCookie(valor: string | null): string | null {
  const m = valor?.match(/^GA\d\.\d+\.(\d+\.\d+)$/);
  return m ? m[1]! : null;
}

/**
 * O início da sessão atual, nos dois formatos que o GA4 já usou:
 * "GS1.1.1700000000.3.1…" e "GS2.1.s1700000000$o3$g1…".
 */
export function sessionIdDoCookie(valor: string | null): string | null {
  if (!valor) return null;
  const v2 = valor.match(/^GS2\.\d+\.s(\d+)/);
  if (v2) return v2[1]!;
  const v1 = valor.match(/^GS1\.\d+\.(\d+)\./);
  return v1 ? v1[1]! : null;
}

/**
 * O que acompanha o pedido. Nulo quando o GA4 não carregou (bloqueador, por
 * exemplo) ou quando o visitante não permitiu cookies analíticos: sem
 * consentimento, o identificador do navegador não sai daqui.
 */
export function idsDoGa(): { clientId: string; sessionId: string | null } | null {
  if (!analyticsPermitido()) return null;
  const clientId = clientIdDoCookie(lerCookie('_ga'));
  if (!clientId) return null;
  return { clientId, sessionId: sessionIdDoCookie(lerCookie(`_ga_${MEASUREMENT_ID.replace(/^G-/, '')}`)) };
}
